import React from 'react'
import './History.scss';

function History() {
  return (
    <div>History</div>
  )
}

export default History